import { ModuleTypeId } from "../../types/DBTables";
import { UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../GlobalDataProvider";
import { DTOModule } from "../../types/building";
import { useParams } from "react-router-dom";
import TextEditor from "../Global/Editors/TextEditor";
import { IKylaVärmeGemensamYta, IModuleKylaVattenburetConfig } from "../../types/ModuleDatas";
import SelectEditor from "../Global/Editors/SelectEditor";
import { nameof } from "../Global/Utils";
import { Table } from "react-bootstrap";
import CheckboxEditor from "../Global/Editors/CheckboxEditor";
import NumberEditor from "../Global/Editors/NumberEditor";
import { useEffect, useMemo } from "react";
import { MapTooltip } from "../../types/globalData";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

const ConfigKylaVattenburet = ({ module, data, formHook }: IProps) => {
  const { buildingId } = useParams();
  const globalData = useGlobalData();

  const building = buildingId ? globalData.buildings?.find((b) => b.id === parseInt(buildingId)) : undefined;
  const formData = formHook.watch("frmData");

  const listVärmesystemModules = useMemo(
    () =>
      building
        ? building.modules.filter(
            (m) =>
              m.moduleTypeId === ModuleTypeId.VarmeSekundarVatten ||
              m.moduleTypeId === ModuleTypeId.VarmeElAirotemper ||
              m.moduleTypeId === ModuleTypeId.VarmeElGolvvarme ||
              m.moduleTypeId === ModuleTypeId.VarmeElRadiatorer ||
              m.moduleTypeId === ModuleTypeId.VarmeElStralningsvarmare ||
              m.moduleTypeId === ModuleTypeId.VarmeElVarmepump
          )
        : [],
    [building]
  );

  const listVärmesystemNames = listVärmesystemModules.map((m) => m.name);
  listVärmesystemNames.splice(0, 0, "");

  useEffect(() => {
    const gemensammaYtor: IKylaVärmeGemensamYta[] = data[nameof<IModuleKylaVattenburetConfig>("värmeSystemGemensamBetjäningsyta")]
      ? data[nameof<IModuleKylaVattenburetConfig>("värmeSystemGemensamBetjäningsyta")]
      : [];
    if (!formData) {
      const allValues = formHook.getValues();
      const newFormData = {} as any;

      listVärmesystemModules.forEach((m, i) => {
        const entry = { active: false, ytaAndel: 0, id: m.id };
        newFormData["o" + m.id] = entry;
        const existingEntry = gemensammaYtor.find((r) => r.värmeModulId === m.id);
        if (existingEntry) {
          entry.active = true;
          entry.ytaAndel = existingEntry.ytaAndel;
        }
      });

      allValues.frmData = newFormData;
      formHook.reset(allValues);
    }
  }, [formData, formHook, listVärmesystemModules, data]);

  if (!building || !formData) return <></>;

  return (
    <>
      <div className="row ml-0">
        <div className="col-lg-12">
          <TextEditor
            label="Betjäningsområde komfortkyla"
            fieldName={nameof<IModuleKylaVattenburetConfig>("betjäningsområde")}
            tooltipId={nameof<MapTooltip>("KylaVattenburet_betjäningsområde")}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange betjäningsområde" : undefined;
                },
              },
            }}
          ></TextEditor>
        </div>
        {listVärmesystemModules.length === 0 ? (
          <></>
        ) : (
          <Table>
            <thead>
              <tr>
                <th style={{ width: 40, textAlign: "center" }}>Betjänas</th>
                <th style={{ width: 200 }}>Yta som betjänas med komfortkyla (%)</th>
                <th>Värmesystem</th>
              </tr>
            </thead>
            <tbody>
              {listVärmesystemModules.map((m, i) => (
                <tr key={m.id}>
                  <td>
                    <CheckboxEditor label="" fieldName={"frmData.o" + m.id + ".active"} formHook={formHook} />
                  </td>
                  <td>
                    <NumberEditor
                      isDisabled={!formData["o" + m.id].active}
                      label=""
                      fieldName={"frmData.o" + m.id + ".ytaAndel"}
                      tooltipId={nameof<MapTooltip>("KylaVattenburet_ytaAndel")}
                      formHook={formHook}
                      min={0}
                      max={100}
                    />
                  </td>
                  <td>{m.name}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </>
  );
};

export default ConfigKylaVattenburet;
